export default __webpack_public_path__ + "static/mobile-small-2x-f15e7adc16db0847a75e39a10c48ac96.jpeg";